<script lang="ts">
    import { t } from "$lib/i18n/translations";
</script>

<div class="queue-stub">
    <!-- Icono minimalista de descarga/lista vacía estilo 1312 -->
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stub-icon">
        <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"></path>
        <polyline points="7 11 12 16 17 11"></polyline>
        <line x1="12" y1="4" x2="12" y2="16"></line>
    </svg>
    <span class="subtext stub-text">
        {$t("queue.stub")}
    </span>
</div>

<style>
    .queue-stub {
        --base-padding: calc(var(--padding) * 1.5);
        font-size: 13px;
        font-weight: 500;
        color: var(--gray);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: var(--base-padding);
        padding-bottom: calc(var(--base-padding) + 16px);
        text-align: center;
        gap: var(--padding);
    }

    .stub-icon {
        color: var(--gray);
        opacity: 0.4;
        margin-bottom: 5px;
    }

    .stub-text {
        padding: 0;
    }
</style>